var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.addNeopassDisplay > -1
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.addNeopassDisplay == 1 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("\n        Ajouter un carnet de parcours\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 my-5 mb-9"
  }, [_vm._v("\n        Veuillez saisir l'identité du bénéficiaire\n      ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-5"
  }, [_c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "libelle": "Prénom",
      "value": (_vm.newNeopass || {}).firstname,
      "error": true,
      "msg-error": ((_vm.errorsNewBeneficiary || {})['beneficiary.firstname'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        (_vm.newNeopass || {}).firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "libelle": "Nom",
      "value": (_vm.newNeopass || {}).lastname,
      "error": true,
      "msg-error": ((_vm.errorsNewBeneficiary || {})['beneficiary.lastname'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        (_vm.newNeopass || {}).lastname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "type": "password",
      "new-password": true,
      "libelle": "Mot de passe",
      "value": (_vm.newNeopass || {}).password
    },
    on: {
      "input": function (newValue) {
        (_vm.newNeopass || {}).password = newValue;
      },
      "click": function ($event) {
        _vm.foo = false;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "type": "password",
      "new-password": true,
      "libelle": "Confirmation du mot de passe",
      "error": _vm.showPasswordError,
      "msg-error": _vm.validatePassword,
      "value": (_vm.newNeopass || {}).password_confirmation
    },
    on: {
      "input": function (newValue) {
        (_vm.newNeopass || {}).password_confirmation = newValue;
      },
      "click": function ($event) {
        _vm.showPasswordError = false;
      }
    }
  }), _vm._v(" "), _vm.saving_create ? _c('div', {
    staticClass: "col-span-full justify-self-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CREER",
      "spinner": true,
      "right": true,
      "type-shadow": "shadow-pink"
    }
  })], 1) : _c('div', {
    staticClass: "col-span-full justify-self-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CREER",
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.create_neopass
    }
  })], 1)], 1)]), _vm._v(" "), _c('h5', {
    staticClass: "my-10"
  }, [_vm._v("\n        OU\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("\n        Si vous souhaitez ajouter un carnet de parcours existant,\n        "), _c('br'), _vm._v("\n        veuillez saisir l’identifiant ou l’adresse email du bénéficiaire\n      ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-11 gap-x-4 gap-y-5"
  }, [_c('input-text', {
    staticClass: "lg:col-span-5",
    attrs: {
      "libelle": "Identifiant",
      "value": (_vm.newNeopass || {}).username
    },
    on: {
      "input": function (newValue) {
        (_vm.newNeopass || {}).username = newValue;
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-span-1 place-self-center mt-5 text-indigo-600"
  }, [_vm._v("OU")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-5",
    attrs: {
      "libelle": "Email",
      "value": (_vm.newNeopass || {}).email
    },
    on: {
      "input": function (newValue) {
        (_vm.newNeopass || {}).email = newValue;
      }
    }
  }), _vm._v(" "), _c('v-errors', {
    staticClass: "col-span-full text-xs font-medium text-red-500",
    attrs: {
      "errors": Object.assign({}, _vm.errorsAttachNeopass)
    }
  }), _vm._v(" "), _vm.saving_link ? _c('div', {
    staticClass: "col-span-full justify-self-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "spinner": true,
      "right": true,
      "type-shadow": "shadow-pink"
    }
  })], 1) : _c('div', {
    staticClass: "col-span-full justify-self-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "icon": "plus-circle",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.link_neopass
    }
  })], 1)], 1)])])]) : _vm.addNeopassDisplay == 2 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-40 2xl:mx-36 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-pink-600 mb-8"
  }, [_vm._v("\n        Carnet de parcours créé !\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_c('p', [_vm._v("\n          Le carnet de parcours de " + _vm._s((_vm.newNeopass || {}).firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s((_vm.newNeopass || {}).lastname))]), _vm._v(" a bien été créé !\n          "), _c('br'), _vm._v("\n          Vous pouvez désormais compléter les pages des différents modules.\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Le bénéficiaire peut se connecter grâce au nom d'utilisateur suivant : ")]), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600"
  }, [_vm._v("\n          " + _vm._s((_vm.newNeopass || {}).username) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-5 w-full flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE) ? _c('div', {
    staticClass: "mr-5"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "CRÉER UN NOUVEAU CARNET",
      "icon": "plus-circle",
      "right": true,
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.open();
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_NEOPASS_FORM_PAGE) ? _c('router-link', {
    attrs: {
      "to": '/form/neopass/' + (_vm.newNeopass || {}).id
    }
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "éditer le carnet",
      "uppercase": true,
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)]) : _vm._e()], 1)])]) : _vm.addNeopassDisplay == 3 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-pink-600 mb-8"
  }, [_vm._v("\n        Carnet de parcours rattaché !\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_c('p', [_vm._v("L'utilisateur " + _vm._s((_vm.newNeopass || {}).firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s((_vm.newNeopass || {}).lastname))]), _vm._v(" a bien été rattaché à votre entreprise.")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-5 w-full flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_FORM_PAGE) ? _c('router-link', {
    attrs: {
      "to": '/form/neopass/' + (_vm.newNeopass || {}).id
    }
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "éditer le carnet",
      "uppercase": true,
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)]) : _vm._e()], 1)])]) : _vm.addNeopassDisplay == 4 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-pink-600 mb-8"
  }, [_vm._v("\n        Carnet de parcours inexistant\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [(_vm.newNeopass || {}).username != '' ? _c('p', [_vm._v("\n          L’identifiant « " + _vm._s((_vm.newNeopass || {}).username) + " » est introuvable.\n        ")]) : (_vm.newNeopass || {}).email != '' ? _c('p', [_vm._v("\n          L’adresse email « " + _vm._s((_vm.newNeopass || {}).email) + " » est introuvable.\n        ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Vous pouvez créer un carnet de parcours pour cette personne ci-dessous. ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "no_result"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-5 w-full flex justify-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CRÉER LE CARNET",
      "uppercase": true,
      "icon": "plus-circle",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.open();
      }
    }
  })], 1)])]) : _vm.addNeopassDisplay == 5 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-pink-600 mb-8"
  }, [_vm._v("\n        Carnet de parcours déjà rattaché\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_c('p', [_vm._v("L'utilisateur " + _vm._s((_vm.newNeopass || {}).firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s((_vm.newNeopass || {}).lastname))]), _vm._v(" a déjà un carnet de parcours rattaché " + _vm._s((_vm.newNeopass || {}).company_id === ((_vm.user.companies || [])[0] || {}).id ? 'à votre structure' : 'à une autre structure'))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-5 w-full flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_FORM_PAGE) && (_vm.newNeopass || {}).company_id === ((_vm.user.companies || [])[0] || {}).id ? _c('router-link', {
    attrs: {
      "to": '/form/neopass/' + (_vm.newNeopass || {}).id
    }
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "éditer le carnet",
      "uppercase": true,
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)]) : _vm._e()], 1)])]) : _vm.addNeopassDisplay == 6 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-36 2xl:mx-32 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-pink-600 mb-8"
  }, [_vm._v("\n        Impossible d'ajouter un carnet de parcours\n      ")]), _vm._v(" "), _vm.$subscription() ? _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_vm._v("\n        Vous ne pouvez pas ajouter un carnet de parcours, car vous avez atteint le nombre de carnet de parcours créé dans votre abonnement \"Standard, " + _vm._s(_vm.$store.getters['auth/subscription'].quantity) + " carnets de parcours\"\n      ")]) : _vm._e(), _vm._v(" "), _vm.$trial() && !_vm.$subscription() ? _c('div', {
    staticClass: "mb-8"
  }, [_c('h6', {
    staticClass: "text-indigo-600 mb-5"
  }, [_c('p', [_vm._v("La version d'essai est limité à 1 carnet de parcours par structure.")]), _vm._v(" "), _c('p', [_vm._v("Faites évoluer votre abonnement afin de profiter de plus de carnet de parcours.")])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex justify-center",
    attrs: {
      "to": {
        name: 'Subscriptionchoice'
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "FAIRE EVOLUER MON OFFRE",
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-5 w-full flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_PARAMETRE_COMPTE_CHANGER_ABONNEMENT) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Accountsubscription'
      }
    }
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER DES CARNETS",
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1)]) : _vm._e()], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }